import axios from "axios";
import getEnv from "../configs/env";
import store from "../store";
import router from "../router/routes";

const api = axios.create({
  baseURL: getEnv("VUE_APP_API"),
});

api.interceptors.request.use(
  (config) => {
    const token = store.getters.getToken;
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch("logout");
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

export default api;
